export const VideoPages = {
  DETAILS: 'details',
  ANALYTICS: 'analytics',
  TRIM: 'trim',
  SEND_AND_SHARE: 'send-and-share',
};
